/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MdCommonModule} from '@angular/material/core';
import {MdProgressBar} from './progress-bar';
export class MdProgressBarModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, MdCommonModule],
  exports: [MdProgressBar, MdCommonModule],
  declarations: [MdProgressBar],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdProgressBarModule_tsickle_Closure_declarations() {
/** @type {?} */
MdProgressBarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdProgressBarModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
